
































































































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import routenames from "../../modules/vRoutedefs";

@Component
export default class RoleInfo extends CommonBase {
    sectionClass = "pa-2";

    get billingInfoPageTo() {
        return routenames.system.billing.path;
    }
}
